<template>
  <div>
    <DepartmentDetail type="new" :submitting="submitting" @submit="submit" />
  </div>
</template>

<script>
import { helper } from '@core/mixins/helper.js';
import DepartmentDetail from '@/views/pages/departments/DepartmentDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    DepartmentDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false
    };
  },

  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .createDepartments(data)
        .then(response => {
          this.$router.push({ name: 'department_list' });
          this.showSuccessMessage(
            `${
              response.message ||
              (this.type === 'new'
                ? this.$t('Create Department Success Message')
                : this.$t('Edit Department Success Message'))
            }`
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
